import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { numberFormat } from 'utils';

export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartStockFinacial({ titleText, data, subText, theme }) {
  const DEFAULT_OPTION = {
    grid: { top: 50, right: 10, bottom: 20, left: 65 },
    title: {
      text: titleText,
      subtext: subText || '(Đơn vị: Tỷ đồng)',
      textStyle: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'Roboto',
      },
      subtextStyle: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 12,
        fontWeight: 400,
        fontFamily: 'Roboto',
      },
    },
    color: ['#F0B90B'],
    tooltip: {
      // show: false,
      trigger: 'item',
      // formatter: `{a} <br/>{b}: {c}`,
      formatter: function (value, index) {
        console.log(value)
        return value.seriesName + '<br />' + value.name + ': ' + numberFormat(value.data, 2);
      },
      textStyle: {
        fontFamily: 'Roboto',
      }
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: 'category',
      data: [],
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: theme === 'dark' ? '#ECECEC' : '#000000',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        show: false,
        alignWithLabel: true,
        length: 3,
      },
      axisLabel: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 12,
        borderColor: theme === 'dark' ? '#ECECEC' : '#000000',
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: theme === 'dark' ? '#818181' : '#000000'
        }
      }
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'left',
      alignTicks: false,
      splitNumber: 3,
      splitLine: {
        show: false,
      },
      axisLabel: {
        color: theme === 'dark' ? '#ECECEC' : '#000000',
        fontSize: 12,
        borderColor: theme === 'dark' ? '#ECECEC' : '#000000',
        showMinLabel: false,
        showMaxLabel: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: theme === 'dark' ? '#818181' : '#000000'
        }
      }
    },
    series: [
      {
        type: 'bar',
        name: titleText,
        barWidth: '40%',
        smooth: true,
        emphasis: {
          focus: 'series',
        },
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const preData = usePrevious(data)

  useEffect(() => {
    if(data && !_.isEqual(data, preData)){
      _mapDataToState();
    }
  }, [data]);

  function _mapDataToState() {
    const newOption = _.cloneDeep(option);

    const _category = _.map(data, 'name');
    const _value = _.map(data, 'value');

    newOption.xAxis.data = _category;
    newOption.series[0].data = _value;

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartStockFinacial);
